import { getLocalizedString } from '../../utils/i18n-utils';

export default function WebAuthnVerifyInfo() {
  return (
    <div>
      <div className="fe_u_margin--bottom-medium">
        <strong>{getLocalizedString('webauthn.verify.biometric.title')}</strong>
        <div>{getLocalizedString('webauthn.verify.biometric.description')}</div>
      </div>
      <div className="fe_u_margin--bottom-medium">
        <strong>{getLocalizedString('webauthn.verify.security.key.title')}</strong>
        <div>{getLocalizedString('webauthn.verify.security.key.description')}</div>
      </div>
    </div>
  );
}
